/// <reference path="../_references.ts"/>
module App.Appointments {
	import INgMap = angular.map.INgMap;
	import BottomDrawerService = App.Helpers.BottomDrawerService;
	import TitleBarService = App.Helpers.TitleBarService;
	import LatLng = google.maps.LatLng;
	import DirectionsResult = google.maps.DirectionsResult;
	import DirectionsStatus = google.maps.DirectionsStatus;

	export class AppointmentOverviewController {
		showMap: boolean;

		distanceText: string = 'Getting Your Location...';

		private data: Appointment = null;
		public destination: LatLng;
		public directionsLink: string;

		statusLoading: boolean = false;

		private map: App.Map = {
			center: null,
			zoom: 18,
			markers: [
				{
					id: 1,
					position: null
				}
			]
		};

		toggleBottomDrawer: (evt: ng.IAngularEvent) => void;

		static $inject = [
			'$scope', '$timeout', 'NgMap', 'SelectedAppointment', 'BottomDrawerService',
			'TitleBarService', 'PermissionService', '$state', 'TelephonyOutboundTools', 'LocationService', 'TimeEventService',
		];

		constructor(
			private $scope: ng.IScope,
			private $timeout: ng.ITimeoutService,
			private NgMap: INgMap,
			private SelectedAppointment: SelectedAppointment,
			private BottomDrawerService: BottomDrawerService,
			private TitleBarService: TitleBarService,
			private PermissionService: App.Helpers.PermissionService,
			private $state: ng.ui.IStateService,
			private TelephonyOutboundTools: any,
			private LocationService: App.Helpers.LocationService,
			protected TimeEventService: App.TimeEvent.TimeEventService
		) {
			SelectedAppointment.getAppointment().then((appointment) => {
				this.setAppointment(appointment);
			});

			TitleBarService.set('Appointment');


			this.toggleBottomDrawer = (evt) => {
				evt.preventDefault();

				const options = [
						{
							text: SelectedAppointment.getEmail(),
							icon: 'fas fa-envelope fa-fw',
							fn: () => {
								let email = SelectedAppointment.getEmail();

								if(email) {
									window.location.href = 'mailto:'+email;
								}
							}
						},
						{
							text: SelectedAppointment.getHours(),
							icon: 'far fa-clock fa-fw'
						},
					],
					phone = SelectedAppointment.getFirstPhone(),
					option_sr =  {
						text: 'SR ' + SelectedAppointment.service_request.id.toString(),
						icon: 'far fa-building fa-fw',
					},
					option_rate = {
						text: SelectedAppointment.service_request.customer.rate_type ? SelectedAppointment.service_request.customer.rate_type.name : '',
						icon: 'far fa-building fa-fw',
					},
					option_appt = {
						text: 'Appt ' + SelectedAppointment.id.toString(),
						icon: 'far fa-building fa-fw',
					},
					option_loc = {
						text: SelectedAppointment.getLocation(),
						icon: 'fas fa-map-marker-alt fa-fw',
					};

				if (TelephonyOutboundTools.showOutboundNumber(phone)) {
					const telephonyNumber = TelephonyOutboundTools.getOutboundNumber(),
						telephonyHref = 'tel:' + telephonyNumber,
						telephonyNumberText = telephonyNumber + ' ext. ' + phone.telephony_ext,
						formatted = SelectedAppointment.formatPhone(phone.number),
						phoneNumber = TelephonyOutboundTools.getPartialNumber(phone, formatted),
						phoneHref = 'tel:' + phoneNumber,
						phoneShowHref = TelephonyOutboundTools.showsFullNumber(phone);

					options.push.apply(options, [{
							text: telephonyNumberText,
							icon: 'fas fa-phone-square fa-fw',
							fn: () => window.location.href = telephonyHref,
						},
						option_sr, {
							text: phoneNumber,
							icon: 'fas fa-phone-square fa-fw',
							fn: phoneShowHref
								? () => window.location.href = phoneHref
								: () => false,
						}, option_appt,
						option_rate,
						option_loc
					]);
				} else {
					options.push.apply(options, [{
							text: phone ? SelectedAppointment.formatPhone(phone.number) : 'No phone found',
							icon: 'fas fa-phone-square fa-fw',
							fn: phone
								? () => window.location.href = 'tel:' + phone.number
								: () => false,
						},
						option_sr,
						option_rate,
						option_appt,
						option_loc,
					]);
				}

				BottomDrawerService.open(options, true);
			};
		}

		setAppointment(appointment: Appointment): void {
			const vm = this;

			vm.data = appointment;

			// Load the appointment if it's not already loaded
			vm.data.getAppointment();

			vm.map.center = vm.data.service_request.service_address.latitude + ' ' + vm.data.service_request.service_address.longitude;
			vm.map.markers[0].position = vm.data.service_request.service_address.latitude + ' ' + vm.data.service_request.service_address.longitude;
			vm.validateDestination();
		}

		validateDestination(): void {
			const vm = this,
				address = vm.data.service_request.service_address;

			if (address.latitude && address.longitude) {
				vm.destination = vm.getDestination();
				vm.getLocation();
			} else {
				vm.distanceText = 'Destination lat/lng not found.';
			}
		}

		getDestination() {
			const vm = this;

			let marker = vm.map.markers[0],
				position, destination: LatLng;

			if(typeof marker.position === 'string') {
				position = marker.position.split(' ');
				destination = new google.maps.LatLng(parseFloat(position[0]), parseFloat(position[1]));
			} else {
				destination = new google.maps.LatLng(marker.latitude, marker.longitude);
			}

			return destination;
		}

		getLocation() {
			let vm = this,
				destinationAddress = vm.data.service_request.service_address.street + ' ' + vm.data.service_request.service_address.city + ' ' + vm.data.service_request.service_address.state + ' ' + vm.data.service_request.service_address.zip;

			vm.directionsLink = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(destinationAddress);
			vm.$timeout(() => {
				this.showMap = true;

				this.LocationService.getLocation().then((coords) => {
					vm.map.markers[1] = {
						id: 2,
						latitude: coords.latitude,
						longitude: coords.longitude
					};

					vm.NgMap.getMap().then(function (map) {
						let directionsDisplay = new google.maps.DirectionsRenderer(),
							directionsService = new google.maps.DirectionsService(),
							request = {
								origin: new google.maps.LatLng(
									coords.latitude,
									coords.longitude
								),
								destination: vm.destination,
								travelMode: google.maps.TravelMode.DRIVING,
								optimizeWaypoints: true
							};

						directionsService.route(request, function (response: DirectionsResult, status: DirectionsStatus) {
							if (response.routes[0]) {
								let withText = '';

								if ((<any>response.routes[0].legs[0]).traffic_speed_entry.length > 0) {
									withText += ' with traffic';
								}

								vm.distanceText = response.routes[0].legs[0].distance.text +
									' - ' + response.routes[0].legs[0].duration.text +
									withText;
							}

							if (status == google.maps.DirectionsStatus.OK) {
								directionsDisplay.setDirections(response);
								directionsDisplay.setMap(map);
							}
						});

					});
				}, function () {
					vm.distanceText = 'Unable to determine location.';
				});
			});
		}

		showStatusButton(): boolean {
			return this.data.appointment_status !== 'Arrived' ||
				this.PermissionService.hasAnyPermission([
					'web.field.price-guide.view',
					'web.field.left-nav.work-order',
					'web.field.left-nav.administrative',
					'web.office.service-requests.service-request.tech-view'
				]);
		}

		changeStatus() : void {
			// Navigate to Price Guide
			if (this.data.appointment_status == 'Arrived') {
				switch (true) {
					case this.PermissionService.hasPermission('web.field.price-guide.view'):
					case this.PermissionService.hasPermission('web.office.service-requests.service-request.tech-view'):
						this.$state.go('zipSolutions.price-guide');
						return;
					case this.PermissionService.hasPermission('web.field.left-nav.work-order'):
						this.$state.go('zipSolutions.workOrder');
						return;
					case this.PermissionService.hasPermission('web.field.left-nav.administrative'):
						this.$state.go('zipSolutions.administrative');
						return;
					default:
						// Don't know where to go next...
						// This should not have happened
						return;
				}

				return;
			}

			let nextStatus: string,
				confirmEvent: boolean = false;
			switch(this.data.appointment_status) {
				case 'Acknowledged':
					nextStatus = 'Started';
					break;
				case 'Started':
				default:
					nextStatus = 'Arrived';
					confirmEvent = this.PermissionService.hasPermission('web.time-clock.field.confirm');
					break;
			}

			this.statusLoading = true;
			this.SelectedAppointment.updateAppointmentStatus(nextStatus)
				.then((response) => {
					this.data = response;

					if (confirmEvent) {
						return this.TimeEventService.confirmLastEvent();
					}
				})
				.finally(() => {
					this.statusLoading = false;

					if (this.SelectedAppointment.getPhone(true, true) !== "No phone found") {
						this.sendCustomerText(nextStatus);
					}
				});
		}

		sendCustomerText(nextStatus: string) {
			const vm = this;

			vm.BottomDrawerService.open([
				{
					text: "Send text",
					icon: 'fas fa-mobile-alt fa-fw',
					fn: () => {
						vm.SelectedAppointment.sendCustomerText(nextStatus);
					}
				},
				{
					text: "Do not send a text",
					icon: 'fas fa-times fa-fw',
					fn: () => {
					}
				}
			], true, false);
		}

		buttonStatus() : string {
			const vm = this;

			switch(vm.data.appointment_status) {
				case 'Acknowledged':
					return 'Start';
				case 'Started':
					return 'Arrive';
				case 'Arrived':
					return 'Next';
				default:
					return 'Arrive';
			}
		}

		displayDate(appointment: Appointment): string {
			return moment(appointment.scheduled_date + ' ' + appointment.scheduled_time, 'YYYY-MM-DD HH:mm').format('ddd, MMM Do YYYY hh:mma');
		}
	}
}